import './App.css';
import {Box, Button, Checkbox, Select, Typography} from "@mui/material";
import React from 'react';
import RplsCtrl from "./svc/ApiUniv";
import EmailIcon from '@mui/icons-material/Email';
import {FaRegFileExcel} from "react-icons/fa";

import {FaFilePdf} from "react-icons/fa";
import {PDFExport} from "@progress/kendo-react-pdf";
import {Margin, Resolution, usePDF} from "react-to-pdf";
import * as turf from "@turf/turf";
import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';
import proj4 from 'proj4';


const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export const exportToCSV = (codeInsee, data, typoLgt, lgtAge) => {
    // Nom des colonnes
    let headers = [];
    Object.keys(data[0]).forEach(key => {
        headers.push(key)
    });

    // Générer le contenu CSV
    const csvRows = [];
    csvRows.push(headers.join(",")); // Ajouter l'entête
    data.forEach(element => {
        let localRow = [];
        Object.keys(data[0]).forEach(key => {
            const value = element[key];

            // 1. Gestion des valeurs nulles ou indéfinies
            if (value === null || value === undefined) {
                localRow.push("");
            }
            // 2. Si la valeur est une chaîne (on retire les virgules)
            else if (typeof value === 'string') {
                localRow.push(value.replaceAll(",", " "));
            }
            // 3. Si c'est un objet (JSON), on remplace les virgules par des tirets
            else if (typeof value === 'object') {
                localRow.push(
                    "'" + JSON.stringify(value) + "'");
            }
            // 4. Pour les autres types (nombres, bohéens)
            else {
                localRow.push(value);
            }
        });
        csvRows.push(localRow.join(","));
    });


    // Convertir en fichier CSV
    const csvString = csvRows.join("\n");


    // Création du BOM UTF-8
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvString], {type: "text/csv;charset=utf-8;"});

    const url = URL.createObjectURL(blob);


    // Télécharger le fichier
    const a = document.createElement("a");
    a.href = url;
    a.download = "RPLS-" + codeInsee + ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

function getFinancementTextFromCode(financement) {
    let obj = JSON.parse(financement);

    return Object.keys(obj).map(key => {
        return key;
    }).join(", ");
}

function getOriginePatrimoine(originPatri) {
    switch (originPatri) {
        case "1":
            return "Construction par l'organisme";
        case "2":
            return "Acquisition avec travaux";
        case "3":
            return "Acquisition sans travaux";
        case "4":
            return "Acquisition en Vefa";
        case "0":
            return "Non renseigné";
        case "NC":
            return "Non conforme";
        default:
            return "Non conforme";

    }
}

function App() {
    const [hoverInfo, setHoverInfo] = React.useState(null);
    const [codeInsee, setCodeInsee] = React.useState(null);
    const urlSearchString = window.location.search;
    const params = new URLSearchParams(urlSearchString);
    const [commune, setCommune] = React.useState(null);
    const [rpls, setRpls] = React.useState(null);
    const [rplsRpls, setRplsRpls] = React.useState(null);
    const [bbox, setBbox] = React.useState(null);

    const [data1, setData1] = React.useState(null);
    const [data2a, setData2a] = React.useState(null);
    const [data2b, setData2b] = React.useState(null);
    const [data3, setData3] = React.useState(null);
    const [data4, setData4] = React.useState(null);
    const [data5a, setData5a] = React.useState(null);
    const [data5b, setData5b] = React.useState(null);

    const [data6a, setData6a] = React.useState(null);
    const [data6b, setData6b] = React.useState(null);

    const [data7a, setData7a] = React.useState(null);
    const [data7b, setData7b] = React.useState(null);

    const [typoLgt, setTypoLgt] = React.useState([true, true, true, true, true, true]);
    const [lgtAge, setLgtAge] = React.useState([true, true, true, true, true, true]);

    const mapRef = React.useRef();
    const options = {
        filename: "advanced-example.pdf", // default is `save`
        method: "save", // default is Resolution.MEDIUM = 3, which should be enough, higher values
        // increases the image quality but also the size of the PDF, so be careful
        // using values higher than 10 when having multiple pages generated, it
        // might cause the page to crash or hang.
        resolution: Resolution.HIGH, page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL, // default is 'A4'
            format: "letter", // default is 'portrait'
            orientation: "landscape",
        }, canvas: {
            // default is 'image/jpeg' for better size performance
            mimeType: "image/png", qualityRatio: 1,
        }, // customize any value passed to the jsPDF instance and html2canvas
        // function
        overrides: {
            // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
            pdf: {
                compress: true,
            }, // see https://html2canvas.hertzen.com/configuration for more options
            canvas: {
                useCORS: true,
            },
        },
    };
    const {toPDF, targetRef} = usePDF({filename: 'page.pdf'}, options);
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const pdfExportComponent = React.useRef(null);
    const exportPDFWithMethod = () => {
        pdfExportComponent.current.save();
    };


    let hrefText = "mailto:?to=contact@terrededonnees.fr&subject=[RPLS] Demande de correction sur la commune " + commune + "(" + codeInsee + ")&body=" + "Bonjour,%0D%0AMerci de corriger les données de localisation sur la commune de " + commune + ".%0D%0A<Ajouter des inforamtions complémentaires si nécessaire>.%0D%0ACordialement, <Mettre votre nom>";

    function extractedData1(data) {
        let data1 = []
        data1.push({
            title: "Biens proposés à la location loués",
            value: data.nb_loues,
            percent: data.nb_loues / data.nb_lgt_tot,
            color: '#f33594'
        })
        data1.push({
            title: "Biens pris en charge par une asso",
            value: data.nb_asso,
            percent: data.nb_asso / data.nb_lgt_tot,
            color: '#f33594'
        })
        data1.push({
            title: "Biens occupés avec ou sans contrepartie financière",
            value: data.nb_occup_finan,
            percent: data.nb_occup_finan / data.nb_lgt_tot,
            color: '#f33594'
        })
        data1.push({
            title: "Biens vides", value: data.nb_vides, percent: data.nb_vides / data.nb_lgt_tot, color: '#f33594'
        })
        data1.push({
            title: "Biens proposés à la location vacants",
            value: data.nb_vacants,
            percent: data.nb_vacants / data.nb_lgt_tot,
            color: '#f33594'
        })
        data1.push({
            title: "Biens occupés pour de l'hébergement temporaire",
            value: data.nb_occup_temp,
            percent: data.nb_occup_temp / data.nb_lgt_tot,
            color: '#f33594'
        })
        setData1(data1)
    }

    function extractedData2(data) {
        let data2a = []
        data2a.push({
            title: "Biens collectifs",
            value: data.nb_ls_collectifs,
            percent: data.nb_ls_collectifs / data.nb_lgt_tot,
            color: '#f33594'
        })
        data2a.push({
            title: "Biens individuels",
            value: data.nb_ls_individuels,
            percent: data.nb_ls_individuels / data.nb_lgt_tot,
            color: '#f33594'
        })
        setData2a(data2a)

        let data2b = []
        data2b.push({
            title: "T1", value: data.nb_ls_1piece, percent: data.nb_ls_1piece / data.nb_lgt_tot, color: '#f33594'
        })
        data2b.push({
            title: "T2", value: data.nb_ls_2piece, percent: data.nb_ls_2piece / data.nb_lgt_tot, color: '#f33594'
        })
        data2b.push({
            title: "T3", value: data.nb_ls_3piece, percent: data.nb_ls_3piece / data.nb_lgt_tot, color: '#f33594'
        })
        data2b.push({
            title: "T4", value: data.nb_ls_4piece, percent: data.nb_ls_4piece / data.nb_lgt_tot, color: '#f33594'
        })
        data2b.push({
            title: "T5 & Plus",
            value: data.nb_ls_5piece_plus,
            percent: data.nb_ls_5piece_plus / data.nb_lgt_tot,
            color: '#f33594'
        })
        setData2b(data2b)
    }

    function extractedData3(data3) {
        let data = []
        const total = data3.age_inf_5 + data3.age_5_10 + data3.age_10_20 + data3.age_20_40 + data3.age_40_60 + data3.age_60_plus
        data.push({
            title: "Tranche d'âge Moins de 5 ans",
            value: data3.age_inf_5,
            percent: data3.age_inf_5 / total,
            color: '#f33594'
        })
        data.push({
            title: "Tranche d'âge Entre 5 et 10 ans",
            value: data3.age_5_10,
            percent: data3.age_5_10 / total,
            color: '#f33594'
        })
        data.push({
            title: "Tranche d'âge Entre 10 et 20 ans",
            value: data3.age_10_20,
            percent: data3.age_10_20 / total,
            color: '#f33594'
        })
        data.push({
            title: "Tranche d'âge Entre 20 et 40 ans",
            value: data3.age_20_40,
            percent: data3.age_20_40 / total,
            color: '#f33594'
        })
        data.push({
            title: "Tranche d'âge Entre 40 et 60 ans",
            value: data3.age_40_60,
            percent: data3.age_40_60 / total,
            color: '#f33594'
        })
        data.push({
            title: "Tranche d'âge plus de 60 ans",
            value: data3.age_60_plus,
            percent: data3.age_60_plus / total,
            color: '#f33594'
        })
        setData3(data)
    }

    function extractedData4(d) {
        let data = []

        data.push({
            title: "Parc Social 2014", value: d.nb_ls2014, percent: (d.nb_ls2014 / d.nb_ls2013) - 1, color: '#182e57'
        })
        data.push({
            title: "Parc Social 2015", value: d.nb_ls2015, percent: (d.nb_ls2015 / d.nb_ls2014) - 1, color: '#2f3672'
        })
        data.push({
            title: "Parc Social 2016", value: d.nb_ls2016, percent: (d.nb_ls2016 / d.nb_ls2015) - 1, color: '#473c8a'
        })
        data.push({
            title: "Parc Social 2017", value: d.nb_ls2017, percent: (d.nb_ls2017 / d.nb_ls2016) - 1, color: '#613fa0'
        })
        data.push({
            title: "Parc Social 2018", value: d.nb_ls2018, percent: (d.nb_ls2018 / d.nb_ls2017) - 1, color: '#7c3fb1'
        })
        data.push({
            title: "Parc Social 2019", value: d.nb_ls2019, percent: (d.nb_ls2019 / d.nb_ls2018) - 1, color: '#983dbb'
        })
        data.push({
            title: "Parc Social 2020", value: d.nb_ls2020, percent: (d.nb_ls2020 / d.nb_ls2019) - 1, color: '#b33abe'
        })
        data.push({
            title: "Parc Social 2021", value: d.nb_ls2021, percent: (d.nb_ls2021 / d.nb_ls2020) - 1, color: '#cd36b9'
        })
        data.push({
            title: "Parc Social 2022", value: d.nb_ls2022, percent: (d.nb_ls2022 / d.nb_ls2021) - 1, color: '#e733ad'
        })
        data.push({
            title: "Parc Social 2023", value: d.nb_ls, percent: (d.nb_ls / d.nb_ls2022) - 1, color: '#f33594'
        })
        setData4(data)
    }

    function extractedData5(d) {
        let data = []
        data.push({
            title: "Tx de vacance 1er Jan 2013", value: d.tx_vac_2013, percent: 0, color: '#182e57'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2014",
            value: d.tx_vac_2014,
            percent: (d.tx_vac_2014 / d.tx_vac_2013) - 1,
            color: '#182e57'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2015",
            value: d.tx_vac_2015,
            percent: (d.tx_vac_2015 / d.tx_vac_2014) - 1,
            color: '#2f3672'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2016",
            value: d.tx_vac_2016,
            percent: (d.tx_vac_2016 / d.tx_vac_2015) - 1,
            color: '#473c8a'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2017",
            value: d.tx_vac_2017,
            percent: (d.tx_vac_2017 / d.tx_vac_2016) - 1,
            color: '#613fa0'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2018",
            value: d.tx_vac_2018,
            percent: (d.tx_vac_2018 / d.tx_vac_2017) - 1,
            color: '#7c3fb1'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2019",
            value: d.tx_vac_2019,
            percent: (d.tx_vac_2019 / d.tx_vac_2018) - 1,
            color: '#983dbb'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2020",
            value: d.tx_vac_2020,
            percent: (d.tx_vac_2020 / d.tx_vac_2019) - 1,
            color: '#b33abe'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2021",
            value: d.tx_vac_2021,
            percent: (d.tx_vac_2021 / d.tx_vac_2020) - 1,
            color: '#cd36b9'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2022",
            value: d.tx_vac_2022,
            percent: (d.tx_vac_2022 / d.tx_vac_2021) - 1,
            color: '#e733ad'
        })
        data.push({
            title: "Tx de vacance 1er Jan 2023",
            value: d.tx_vac,
            percent: (d.tx_vac / d.tx_vac_2022) - 1,
            color: '#f33594'
        })
        setData5a(data)
        let datab = []

        datab.push({
            title: "Tx de mobilitié 1er Jan 2013", value: d.tx_mob_2013, percent: 0, color: '#182e57'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2014",
            value: d.tx_mob_2014,
            percent: (d.tx_mob_2014 / d.tx_mob_2013) - 1,
            color: '#182e57'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2015",
            value: d.tx_mob_2015,
            percent: (d.tx_mob_2015 / d.tx_mob_2014) - 1,
            color: '#2f3672'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2016",
            value: d.tx_mob_2016,
            percent: (d.tx_mob_2016 / d.tx_mob_2015) - 1,
            color: '#473c8a'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2017",
            value: d.tx_mob_2017,
            percent: (d.tx_mob_2017 / d.tx_mob_2016) - 1,
            color: '#613fa0'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2018",
            value: d.tx_mob_2018,
            percent: (d.tx_mob_2018 / d.tx_mob_2017) - 1,
            color: '#7c3fb1'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2019",
            value: d.tx_mob_2019,
            percent: (d.tx_mob_2019 / d.tx_mob_2018) - 1,
            color: '#983dbb'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2020",
            value: d.tx_mob_2020,
            percent: (d.tx_mob_2020 / d.tx_mob_2019) - 1,
            color: '#b33abe'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2021",
            value: d.tx_mob_2021,
            percent: (d.tx_mob_2021 / d.tx_mob_2020) - 1,
            color: '#cd36b9'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2022",
            value: d.tx_mob_2022,
            percent: (d.tx_mob_2022 / d.tx_mob_2021) - 1,
            color: '#e733ad'
        })
        datab.push({
            title: "Tx de mobilitié 1er Jan 2023",
            value: d.tx_mob,
            percent: (d.tx_mob / d.tx_mob_2022) - 1,
            color: '#f33594'
        })
        setData5b(datab)
    }

    function extractedData6(d) {
        let data = []

        let total = d.nb_ls_plus_av_77 + d.nb_ls_plus_ap_77 + d.nb_ls_plai + d.nb_ls_pls + d.nb_ls_pli
        data.push({
            title: "Financement PLUS avant 1977",
            value: d.nb_ls_plus_av_77,
            percent: d.nb_ls_plus_av_77 / total,
            color: '#f33594'
        })
        data.push({
            title: "Financement PLUS après 1977",
            value: d.nb_ls_plus_ap_77,
            percent: d.nb_ls_plus_ap_77 / total,
            color: '#f33594'
        })
        data.push({
            title: "Financement PLAI", value: d.nb_ls_plai, percent: d.nb_ls_plai / total, color: '#f33594'
        })
        data.push({
            title: "Financement PLS", value: d.nb_ls_pls, percent: d.nb_ls_pls / total, color: '#f33594'
        })
        data.push({
            title: "Financement PLI", value: d.nb_ls_pli, percent: d.nb_ls_pli / total, color: '#f33594'
        })

        setData6a(data)
        let datab = []

        datab.push({
            title: "Financement PLUS avant 1977", value: d.loymoy_plus_av, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Financement PLUS après 1977", value: d.loymoy_plus_ap, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Financement PLAI", value: d.loymoy_plai, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Financement PLS", value: d.loymoy_pls, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Financement PLI", value: d.loymoy_pli, percent: 0, color: '#f33594'
        })

        setData6b(datab)
    }

    function extractedData7(d) {
        let data = []

        data.push({
            title: "Loyer moyen 14",
            value: d.loymoy_2014,
            percent: (d.loymoy_2014 / d.loymoy_2013) - 1,
            color: '#182e57'
        })

        data.push({
            title: "Loyer moyen 15",
            value: d.loymoy_2015,
            percent: (d.loymoy_2015 / d.loymoy_2014) - 1,
            color: '#2f3672'
        })

        data.push({
            title: "Loyer moyen 16",
            value: d.loymoy_2016,
            percent: (d.loymoy_2016 / d.loymoy_2015) - 1,
            color: '#473c8a'
        })

        data.push({
            title: "Loyer moyen 17",
            value: d.loymoy_2017,
            percent: (d.loymoy_2017 / d.loymoy_2016) - 1,
            color: '#613fa0'
        })

        data.push({
            title: "Loyer moyen 18",
            value: d.loymoy_2018,
            percent: (d.loymoy_2018 / d.loymoy_2017) - 1,
            color: '#7c3fb1'
        })

        data.push({
            title: "Loyer moyen 19",
            value: d.loymoy_2019,
            percent: (d.loymoy_2019 / d.loymoy_2018) - 1,
            color: '#983dbb'
        })

        data.push({
            title: "Loyer moyen 20",
            value: d.loymoy_2020,
            percent: (d.loymoy_2020 / d.loymoy_2019) - 1,
            color: '#b33abe'
        })

        data.push({
            title: "Loyer moyen 21",
            value: d.loymoy_2021,
            percent: (d.loymoy_2021 / d.loymoy_2020) - 1,
            color: '#cd36b9'
        })

        data.push({
            title: "Loyer moyen 22",
            value: d.loymoy_2022,
            percent: (d.loymoy_2022 / d.loymoy_2021) - 1,
            color: '#e733ad'
        })

        data.push({
            title: "Loyer moyen 23", value: d.loymoy, percent: (d.loymoy / d.loymoy_2022) - 1, color: '#f33594'
        })
        setData7a(data)
        let datab = []

        datab.push({
            title: "Loyer moyen constructions de 5 ans ou moins", value: d.loymoy_inf_5, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Loyer moyen constructions entre 5 ans et 10 ans", value: d.loymoy_5_10, percent: 0, color: '#f33594'
        })
        datab.push({
            title: "Loyer moyen constructions entre 10 ans et 20 ans",
            value: d.loymoy_10_20,
            percent: 0,
            color: '#f33594'
        })
        datab.push({
            title: "Loyer moyen constructions entre 20 ans et 40 ans",
            value: d.loymoy_20_40,
            percent: 0,
            color: '#f33594'
        })
        datab.push({
            title: "Loyer moyen constructions entre 40 ans et 60 ans",
            value: d.loymoy_40_60,
            percent: 0,
            color: '#f33594'
        })
        datab.push({
            title: "Loyer moyen constructions plus de 60 ans", value: d.loymoy_60_plus, percent: 0, color: '#f33594'
        })

        setData7b(datab)
    }

    React.useEffect(() => {

        let id = params.get("codeInsee");
        if (!id) {
            id = params.get("city");
        }
        if (!id) {
            id = "06088"
        }
        setCodeInsee(id);
        RplsCtrl.getRpls(id, (data) => {


            setRpls(data);
            extractedData1(data);
            extractedData2(data);
            extractedData3(data);
            extractedData4(data);
            extractedData5(data);
            extractedData6(data);
            extractedData7(data);
        })

        RplsCtrl.getCommune(id, (data) => {
            setCommune(data)
        })
        RplsCtrl.getRplsRpls(id, (data) => {
            setRplsRpls(data)
            let minLat = Infinity;
            let maxLat = -Infinity;
            let minLng = Infinity;
            let maxLng = -Infinity;
            data.forEach(p => {
                let latLong = convertToLatLon(p.lat, p.lon)
                if (latLong.lat < minLat) minLat = latLong.lat;
                if (latLong.lat > maxLat) maxLat = latLong.lat;
                if (latLong.lng < minLng) minLng = latLong.lng;
                if (latLong.lng > maxLng) maxLng = latLong.lng;
            });

            setBbox({
                sw: [minLng, minLat], // South-West
                ne: [maxLng, maxLat]  // North-East
            });
        })
    }, [])

    const LAMBERT_93 = "+proj=lcc +lat_1=49 +lat_2=44 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";

    const convertToLatLon = (x, y) => {
        // Proj4 attend [longitude, latitude] ou [x, y]
        // La fonction retourne [longitude, latitude]
        const [lng, lat] = proj4(LAMBERT_93, "EPSG:4326", [x, y]);
        return {lat, lng};
    };

    function generateGeoJsonFromRpls() {
        let res = {
            "type": "FeatureCollection", "features": []
        }
        rplsRpls.forEach((elem, i) => {
            let coord = convertToLatLon(elem.lat, elem.lon)
            let visible = true;

            if (elem.nbLog >= 100 && !typoLgt[5]) {
                visible = false;
            }
            if (elem.nbLog < 100 && elem.nbLog >= 50 && !typoLgt[4]) {
                visible = false;
            }
            if (elem.nbLog < 50 && elem.nbLog >= 25 && !typoLgt[3]) {
                visible = false;
            }
            if (elem.nbLog < 25 && elem.nbLog >= 15 && !typoLgt[2]) {
                visible = false;
            }
            if (elem.nbLog < 15 && elem.nbLog >= 5 && !typoLgt[1]) {
                visible = false;
            }
            if (elem.nbLog < 5 && elem.nbLog >= 0 && !typoLgt[0]) {
                visible = false;
            }

            if (Number(elem.anneeCons) >= 2010 && !lgtAge[5]) {
                visible = false;
            }
            if (Number(elem.anneeCons) < 2010 && Number(elem.anneeCons) >= 2000 && !lgtAge[4]) {
                visible = false;
            }
            if (Number(elem.anneeCons) < 2000 && Number(elem.anneeCons) >= 1990 && !lgtAge[3]) {
                visible = false;
            }
            if (Number(elem.anneeCons) < 1990 && Number(elem.anneeCons) >= 1970 && !lgtAge[2]) {
                visible = false;
            }
            if (Number(elem.anneeCons) < 1970 && Number(elem.anneeCons) >= 1940 && !lgtAge[1]) {
                visible = false;
            }
            if (Number(elem.anneeCons) < 1940 && Number(elem.anneeCons) >= 0 && !lgtAge[0]) {
                visible = false;
            }

            if (visible) {
                res.features.push({
                    "type": "Feature",
                    "properties": elem,
                    "geometry": {"type": "Point", "coordinates": [coord.lng, coord.lat, 0.0]}
                })
            }
        })

        return res;
    }

    const onHover = React.useCallback(event => {
        const {
            features,
            point: {x, y}
        } = event;

        // On récupère la feature sous le curseur si elle appartient au layer 'data'
        const hoveredFeature = features && features[0];


        setHoverInfo(hoveredFeature ? {
            feature: hoveredFeature,
            x,
            y
        } : null);
    }, []);

    const onClick = (event) => {
        const feature = event.features && event.features[0];
        if (feature) {
            setHoverInfo(feature);
            let res = convertToLatLon(feature.properties.lat, feature.properties.lon);
            mapRef.current.easeTo({
                center: [res.lng, res.lat],
                offset: [-150, 150], // [x, y] en pixels. -150 déplace la vue vers le haut.
                duration: 800
            });
        }
    };

    if (commune && rpls && rplsRpls && bbox) {
        return (<PDFExport scale={0.3} margin="0.8cm" forcePageBreak=".page-break" ref={pdfExportComponent}
                           paperSize="A4"
                           fileName={codeInsee + '.pdf'}>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
                    <Button startIcon={<FaFilePdf/>} variant={'contained'} sx={{
                        width: 150, backgroundColor: "#f58383", zIndex: 999, position: "fixed", top: 15, right: 15
                    }}
                            onClick={() => {
                                exportPDFWithMethod();

                            }}>
                        Export
                    </Button>
                    <Box sx={{
                        display: "flex",
                        gap: 5,
                        flexDirection: "column",
                        mt: 5,
                        mr: 5,
                        ml: 5,
                        p: 5,
                        borderStyle: "solid",
                        borderRadius: 2,
                        borderWidth: 2,
                        borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation des logements sociaux par
                            typologies de
                            mises à disposition (1/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre et en % (poids de chaque catégorie par
                                rapport
                                au
                                total)</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>
                            <Typography>Nombre de logements total RPLS
                                : {Intl.NumberFormat("fr-FR", {}).format(rpls.nb_lgt_tot)}
                            </Typography>
                        </Box>
                        <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                            <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Nbre de biens
                                composant le
                                parc
                                social 2025</Typography>
                            {data1 && data1.map((elem, k) => {
                                let visible = true;
                                if (elem.value === 0) {
                                    visible = false;
                                }
                                return (<Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }}
                                    key={k}>
                                    <Typography sx={{width: 500}}>{elem.title}</Typography>
                                    <Box sx={{
                                        width: "calc(100% - 520px)",
                                        display: "flex",
                                        gap: 2,
                                        flexDirection: "row",
                                        justifyContent: "flex-start"
                                    }}> <Box sx={{
                                        width: 500 * elem.percent, height: 20, backgroundColor: elem.color
                                    }}/>
                                        {visible && <Typography>{Intl.NumberFormat("fr-FR", {}).format(elem.value)}
                                            &nbsp;/&nbsp;
                                            {Intl.NumberFormat("fr-FR", {
                                                style: "percent", minimumFractionDigits: 1,
                                            }).format(elem.percent)}</Typography>}
                                        {!visible && <Typography>Aucun</Typography>}
                                    </Box>
                                </Box>)
                            })}

                        </Box>
                        <Box>
                            <Typography>Données en nombre et en % (poids de chaque catégorie par rapport au
                                total)</Typography>
                        </Box>
                        <Box>
                            <Typography>Le répertoire des logements locatifs des bailleurs sociaux (RPLS) a pour
                                objectif de
                                dresser l’état global du parc de logements locatifs de ces bailleurs sociaux au 1er
                                janvier
                                d’une année. Il est alimenté par les informations transmises par les bailleurs
                                sociaux.
                                La
                                transmission des informations pour la mise à jour annuelle du répertoire des
                                logements
                                locatifs
                                est obligatoire.</Typography>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation des logements sociaux par
                            types
                            et
                            typologies de biens (2/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre et en % (poids de chaque catégorie par
                                rapport
                                au
                                total)</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>

                        </Box>
                        <Box sx={{display: "flex", gap: 2, flexDirection: "row"}}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Segmentation
                                    par
                                    types
                                    de
                                    biens</Typography>
                                {data2a && data2a.map((elem, k) => {
                                    let visible = true;
                                    if (elem.value === 0) {
                                        visible = false;
                                    }
                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 150}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 170px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 500 * elem.percent, height: 20, backgroundColor: elem.color
                                            }}/>
                                            {visible &&
                                                <Typography>{Intl.NumberFormat("fr-FR", {}).format(elem.value)}
                                                    &nbsp;/&nbsp;
                                                    {Intl.NumberFormat("fr-FR", {
                                                        style: "percent", minimumFractionDigits: 1,
                                                    }).format(elem.percent)}</Typography>}
                                            {!visible && <Typography>Aucun</Typography>}
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Segmentation
                                    par
                                    typologies
                                    de biens</Typography>
                                {data2b && data2b.map((elem, k) => {
                                    let visible = true;
                                    if (elem.value === 0) {
                                        visible = false;
                                    }
                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 150}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 170px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 500 * elem.percent, height: 20, backgroundColor: elem.color
                                            }}/>
                                            {visible &&
                                                <Typography>{Intl.NumberFormat("fr-FR", {}).format(elem.value)}
                                                    &nbsp;/&nbsp;
                                                    {Intl.NumberFormat("fr-FR", {
                                                        style: "percent", minimumFractionDigits: 1,
                                                    }).format(elem.percent)}</Typography>}
                                            {!visible && <Typography>Aucun</Typography>}
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation des logements sociaux par
                            tranches
                            d’âges de construction (3/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre et en % (poids de chaque catégorie par
                                rapport
                                au
                                total)</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>


                        </Box>
                        <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                            <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Répartition des
                                logements
                                sociaux par tranches d'age</Typography>
                            {data3 && data3.map((elem, k) => {
                                let visible = true;
                                if (elem.value === 0) {
                                    visible = false;
                                }
                                return (<Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }}
                                    key={k}>
                                    <Typography sx={{width: 250}}>{elem.title}</Typography>
                                    <Box sx={{
                                        width: "calc(100% - 270px)",
                                        display: "flex",
                                        gap: 2,
                                        flexDirection: "row",
                                        justifyContent: "flex-start"
                                    }}>
                                        <Box sx={{
                                            width: 500 * elem.percent, height: 20, backgroundColor: elem.color
                                        }}/>
                                        {visible && <Typography>{Intl.NumberFormat("fr-FR", {}).format(elem.value)}
                                            &nbsp;/&nbsp;
                                            {Intl.NumberFormat("fr-FR", {
                                                style: "percent", minimumFractionDigits: 1,
                                            }).format(elem.percent)}</Typography>}
                                        {!visible && <Typography>Aucun</Typography>}
                                    </Box>
                                </Box>)
                            })}
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation de l’évolution du nombre de
                            logements
                            sociaux (4/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre (Evolution N VS N-1)</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>
                        </Box>
                        <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                            <Typography sx={{textDecoration: "underline"}}>Commune de NICE : Nombre de logements du
                                parc
                                social etévolution NVS N-1</Typography>
                            {data4 && data4.map((elem, k) => {

                                const last = data4[data4.length - 1];
                                return (<Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }}
                                    key={k}>
                                    <Typography sx={{width: 250}}>{elem.title}</Typography>
                                    <Box sx={{
                                        width: "calc(100% - 270px)",
                                        display: "flex",
                                        gap: 2,
                                        flexDirection: "row",
                                        justifyContent: "flex-start"
                                    }}> <Box sx={{
                                        width: 500 * (elem.value / last.value),
                                        height: 20,
                                        backgroundColor: elem.color
                                    }}/>
                                        <Typography>{Intl.NumberFormat("fr-FR", {}).format(elem.value)}
                                            &nbsp;/&nbsp;
                                            {elem.percent > 0 ? "+" : ""}
                                            {Intl.NumberFormat("fr-FR", {
                                                style: "percent", minimumFractionDigits: 1,
                                            }).format(elem.percent)}</Typography>

                                    </Box>
                                </Box>)
                            })}
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation de la vacance et de la
                            mobilité
                            au
                            sein
                            des logements sociaux
                            (5/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données au 1er janvier de chaque année</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>

                        </Box>
                        <Box sx={{display: "flex", gap: 2, flexDirection: "row"}}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Tx de vacance
                                    au
                                    1er
                                    janvier de chaque année</Typography>
                                {data5a && data5a.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);
                                    if (elem.percent !== 0) {
                                        text += " / " + Intl.NumberFormat("fr-FR", {
                                            style: "percent", minimumFractionDigits: 1,
                                        }).format(elem.percent)
                                    }
                                    let max = data5a[0].value
                                    data5a.forEach(e => {
                                        if (e.value > max) {
                                            max = e.value
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 220}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 240px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 350 * (elem.value / max),
                                                height: 20,
                                                backgroundColor: elem.color
                                            }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Tx de mobilité
                                    au
                                    1er
                                    janvier de chaque année</Typography>
                                {data5b && data5b.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);
                                    if (elem.percent !== 0) {
                                        text += " / " + Intl.NumberFormat("fr-FR", {
                                            style: "percent", minimumFractionDigits: 1,
                                        }).format(elem.percent)
                                    }
                                    let max = data5a[0].value
                                    data5b.forEach(e => {
                                        if (e.value > max) {
                                            max = e.value
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 220}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 240px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 300 * (elem.value / max),
                                                height: 20,
                                                backgroundColor: elem.color
                                            }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation des loyer moyen annuel et
                            par
                            tranche
                            d’âges de construction (6/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>

                        </Box>
                        <Box sx={{display: "flex", gap: 2, flexDirection: "row"}}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Mode de
                                    financement
                                    parc social</Typography>
                                {data6a && data6a.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);
                                    if (elem.percent !== 0) {
                                        text += " / " + Intl.NumberFormat("fr-FR", {
                                            style: "percent", minimumFractionDigits: 1,
                                        }).format(elem.percent)
                                    }
                                    let max = data5a[0].value
                                    data6a.forEach(e => {
                                        if (e.value > max) {
                                            max = e.value
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 250}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 270px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 350 * elem.percent, height: 20, backgroundColor: elem.color
                                            }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Loyer moyen
                                    par
                                    m.2
                                    selon le mode de financement</Typography>
                                {data6b && data6b.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);
                                    let max = data5a[0].value
                                    data6b.forEach(e => {
                                        if (e.value > max) {
                                            max = e.value
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 250}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 270px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 350 * (elem.value / max),
                                                height: 20,
                                                backgroundColor: elem.color
                                            }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}>
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Visualisation des logements sociaux par
                            mode
                            de
                            financement et loyers afférents (7/8)</Typography>
                        <Box>
                            <Typography variant={"h6"}>Données en nombre et en % (poids de chaque catégorie par
                                rapport
                                au
                                total)</Typography>
                            <Typography>Source : Répertoire du Patrimoine Locatif Social 2025</Typography>
                            <Typography>Dernière Date de mise à jour : Janvier 2025</Typography>
                        </Box>
                        <Box sx={{display: "flex", gap: 2, flexDirection: "row"}}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Loyer moyen
                                    par
                                    M2.
                                    par année et évolution NVS N-1</Typography>
                                {data7a && data7a.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);
                                    if (elem.percent !== 0) {
                                        text += " / ";
                                        if (elem.percent > 0) {
                                            text += "+"
                                        }
                                        text += Intl.NumberFormat("fr-FR", {
                                            style: "percent", minimumFractionDigits: 1,
                                        }).format(elem.percent)
                                    }
                                    let max = data7a[0].percent
                                    data7a.forEach(e => {
                                        if (e.percent > max) {
                                            max = e.percent
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 200}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 220px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}> <Box sx={{
                                            width: 350 * (elem.percent / max),
                                            height: 20,
                                            backgroundColor: elem.color
                                        }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                borderStyle: "solid",
                                borderWidth: 2,
                                borderColor: "#d6d6d6",
                                borderRadius: 2,
                                p: 2,
                                width: "49%"
                            }}>
                                <Typography sx={{textDecoration: "underline"}}>Commune de {commune} : Loyer moyen
                                    par
                                    tranches d'âges de construction</Typography>
                                {data7b && data7b.map((elem, k) => {

                                    let text = Intl.NumberFormat("fr-FR", {
                                        maximumFractionDigits: 1,
                                    }).format(elem.value);

                                    let max = data7b[0].value
                                    data7b.forEach(e => {
                                        if (e.value > max) {
                                            max = e.value
                                        }
                                    });


                                    return (<Box sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        width: "98%",
                                        gap: 2,
                                        justifyContent: "flex-start"
                                    }} key={k}>
                                        <Typography sx={{width: 330}}>{elem.title}</Typography>
                                        <Box sx={{
                                            width: "calc(100% - 350px)",
                                            display: "flex",
                                            gap: 2,
                                            flexDirection: "row",
                                            justifyContent: "flex-start"
                                        }}>
                                            <Box sx={{
                                                width: 300 * (elem.value / max),
                                                height: 20,
                                                backgroundColor: elem.color
                                            }}/>
                                            <Typography>
                                                {text}
                                            </Typography>
                                        </Box>
                                    </Box>)
                                })}
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex", gap: 5, flexDirection: "column", mr: 5, ml: 5,

                        p: 5, borderStyle: "solid", borderRadius: 2, borderWidth: 2, borderColor: "#d6d6d6"
                    }}
                         className="page-break">
                        <Typography variant={"h5"} sx={{color: "#250bdf"}}>Logements sociaux du RPLS Géolocalisés
                            (8/8)</Typography>
                        <Box>
                            <Box sx={{display: "flex", gap: 8, flexDirection: "row", justifyContent: "center"}}>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>- de 5 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#0b3a4c"}}/>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>de 5 à 15 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#1784ab"}}/>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>de 15 à 25 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#09ce9a"}}/>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>de 25 à 50 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#f5c962"}}/>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>de 50 à 100 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#f07f0a"}}/>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row"}}>
                                    <Typography>plus de 100 logements</Typography>
                                    <Box sx={{width: 55, height: 22, backgroundColor: "#e6456b"}}/>
                                </Box>
                            </Box>
                        </Box>
                        <Box sx={{display: "flex", flexDirection: "row", gap: 10}}>
                            <Box sx={{display: "flex", gap: 1, flexDirection: "column"}}>
                                <Typography variant={"h6"}>Typologie des logements</Typography>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[0]} onClick={() => {
                                        setTypoLgt([!typoLgt[0], typoLgt[1], typoLgt[2], typoLgt[3], typoLgt[4], typoLgt[5]])
                                    }}/>
                                    <Typography>- de 5 logements</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[1]} onClick={() => {
                                        setTypoLgt([typoLgt[0], !typoLgt[1], typoLgt[2], typoLgt[3], typoLgt[4], typoLgt[5]])
                                    }}/>
                                    <Typography>de 5 à 15 logements</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[2]}
                                        onClick={() => {
                                            setTypoLgt([typoLgt[0], typoLgt[1], !typoLgt[2], typoLgt[3], typoLgt[4], typoLgt[5]])
                                        }}/>

                                    <Typography>de 15 à 25 logements</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[3]}
                                        onClick={() => {
                                            setTypoLgt([typoLgt[0], typoLgt[1], typoLgt[2], !typoLgt[3], typoLgt[4], typoLgt[5]])
                                        }}/>
                                    <Typography>de 25 à 50 logements</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[4]}
                                        onClick={() => {
                                            setTypoLgt([typoLgt[0], typoLgt[1], typoLgt[2], typoLgt[3], !typoLgt[4], typoLgt[5]])
                                        }}/>
                                    <Typography>de 50 à 100 logements</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={typoLgt[5]}
                                        onClick={() => {
                                            setTypoLgt([typoLgt[0], typoLgt[1], typoLgt[2], typoLgt[3], typoLgt[4], !typoLgt[5]])
                                        }}/>
                                    <Typography>plus de 100 logements</Typography>
                                </Box>
                                <Typography variant={"h6"}>Tranches d'âges</Typography>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox checked={lgtAge[0]}
                                              onClick={() => {
                                                  setLgtAge([!lgtAge[0], lgtAge[1], lgtAge[2], lgtAge[3], lgtAge[4], lgtAge[5]])
                                              }}/>
                                    <Typography>&lt;1940</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={lgtAge[1]}
                                        onClick={() => {
                                            setLgtAge([lgtAge[0], !lgtAge[1], lgtAge[2], lgtAge[3], lgtAge[4], lgtAge[5]])
                                        }}/>

                                    <Typography>1940 à 1970</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={lgtAge[2]}
                                        onClick={() => {
                                            setLgtAge([lgtAge[0], lgtAge[1], !lgtAge[2], lgtAge[3], lgtAge[4], lgtAge[5]])
                                        }}/>
                                    <Typography>1970 à 1990</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={lgtAge[3]}
                                        onClick={() => {
                                            setLgtAge([lgtAge[0], lgtAge[1], lgtAge[2], !lgtAge[3], lgtAge[4], lgtAge[5]])
                                        }}/>
                                    <Typography>1990 à 2000</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={lgtAge[4]}
                                        onClick={() => {
                                            setLgtAge([lgtAge[0], lgtAge[1], lgtAge[2], lgtAge[3], !lgtAge[4], lgtAge[5]])
                                        }}/>
                                    <Typography>2000 à 2010</Typography>
                                </Box>
                                <Box sx={{display: "flex", gap: 1, flexDirection: "row", alignItems: "center"}}>
                                    <Checkbox
                                        checked={lgtAge[5]}
                                        onClick={() => {
                                            setLgtAge([lgtAge[0], lgtAge[1], lgtAge[2], lgtAge[3], lgtAge[4], !lgtAge[5]])
                                        }}/>
                                    <Typography>&gt;2010</Typography>
                                </Box>
                                <Button variant={"contained"} sx={{backgroundColor: "#1e7143"}}
                                        onClick={() => {
                                            exportToCSV(codeInsee, rplsRpls, typoLgt, lgtAge)
                                        }}
                                        startIcon={<FaRegFileExcel/>}>
                                    Export excel
                                </Button>
                            </Box>
                            <Box sx={{display: "flex", gap: 1, flexDirection: "column"}}>
                                <Map
                                    ref={mapRef}
                                    mapStyle="mapbox://styles/mapbox/streets-v9"
                                    mapboxAccessToken={MAPBOX_TOKEN}
                                    initialViewState={{
                                        bounds: [bbox.ne[0], bbox.ne[1], bbox.sw[0], bbox.sw[1]],
                                        fitBoundsOptions: {padding: 40} // Ajoute une marge autour des points
                                    }}
                                    onClick={onClick}
                                    interactiveLayerIds={['data']}
                                >
                                    <Source
                                        type="geojson"
                                        data={generateGeoJsonFromRpls()}
                                    >
                                        <Layer
                                            id={'data'}
                                            source={'bans'}
                                            type={'circle'}
                                            paint={{
                                                'circle-color': [
                                                    'step',
                                                    ['get', 'nbLog'],
                                                    '#0b3a4c',   // Couleur par défaut (si nbLog < 10)
                                                    5, '#1784ab', // Si nbLog >= 10
                                                    15, '#09ce9a', // Si nbLog >= 10
                                                    25, '#f5c962', // Si nbLog >= 50
                                                    50, '#f07f0a', // Si nbLog >= 100
                                                    100, '#e6456b'  // Si nbLog >= 500
                                                ],
                                                'circle-radius': 6,
                                                'circle-stroke-width': 1,
                                                'circle-stroke-color': '#fff'
                                            }}
                                        />
                                    </Source>
                                    {hoverInfo && (
                                        <Popup
                                            longitude={hoverInfo.geometry.coordinates[0]}
                                            latitude={hoverInfo.geometry.coordinates[1]}
                                            offset={15}
                                            anchor="bottom"
                                            closeButton={true}
                                            closeOnClick={false}
                                            focusAfterOpen={false}
                                            maxWidth="none"
                                            style={{zIndex: 9999, pointerEvents: 'none'}}
                                            onClose={() => setHoverInfo(null)}
                                        >

                                            <Box sx={{padding: '5px', color: '#333'}}>
                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                    <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                        Iris
                                                    </Typography>
                                                    <Typography variant="subtitle2">
                                                        {hoverInfo.properties.plg_IRIS2022}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                    <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                        Date de construction
                                                    </Typography>
                                                    <Typography variant="subtitle2">
                                                        {hoverInfo.properties.anneeCons}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                    <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                        Date d'entré dans le patrimoine
                                                    </Typography>
                                                    <Typography variant="subtitle2">
                                                        {hoverInfo.properties.anneePatri}
                                                    </Typography>
                                                </Box>


                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                    <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                        Type de propriété
                                                    </Typography>
                                                    <Typography variant="subtitle2">
                                                        {hoverInfo.properties.typeProp}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                    <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                        Logements
                                                    </Typography>
                                                    <Typography variant="subtitle2">
                                                        {hoverInfo.properties.nbLog}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                }}>
                                                    <Typography variant="subtitle2"
                                                                sx={{fontWeight: 'bold', width: "100%"}}>
                                                        Mode de financement
                                                    </Typography>
                                                    <Box sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 1,
                                                        width: "90%"
                                                    }}>
                                                        {Object.keys(JSON.parse(hoverInfo.properties.financement)).map((f, index) => {
                                                            return (
                                                                <Box key={index} sx={{
                                                                    width: "100%",
                                                                    display: "flex",
                                                                    gap: 1,
                                                                    flexDirection: "row",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <Box sx={{width: 50}}/>
                                                                    <Typography variant="subtitle2">
                                                                        {f}
                                                                    </Typography>
                                                                </Box>)
                                                        })}
                                                    </Box>
                                                </Box>

                                            </Box>
                                            <Box sx={{
                                                display: "flex",
                                                gap: 1,
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }}>
                                                <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                    Origine du patrimoine
                                                </Typography>
                                                <Typography variant="subtitle2">
                                                    {getOriginePatrimoine(hoverInfo.properties.originPatri)}
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                display: "flex",
                                                gap: 1,
                                                flexDirection: "row",
                                                alignItems: "center"
                                            }}>
                                                <Typography variant="subtitle2" sx={{fontWeight: 'bold'}}>
                                                    Typologie des logements
                                                </Typography>
                                                <Typography variant="subtitle2">
                                                    {hoverInfo.properties.typeLog}
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                display: "flex",
                                                gap: 1,
                                                flexDirection: "row",
                                                alignItems: "flex-start",

                                            }}>
                                                <Typography variant="subtitle2" sx={{fontWeight: 'bold', width: "30%"}}>
                                                    Type de biens
                                                </Typography>
                                                <Box sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 1,
                                                    width: "60%"
                                                }}>
                                                    {Object.keys(JSON.parse(hoverInfo.properties.nbPieces)).map((nb, index) => {
                                                        return (<Box key={index} sx={{
                                                            width: "100%",
                                                            display: "flex",
                                                            gap: 1,
                                                            flexDirection: "row",
                                                            alignItems: "center"
                                                        }}>
                                                            <Box sx={{width: 50}}/>
                                                            <Typography variant="subtitle2"
                                                                        sx={{fontWeight: 'bold', width: "49%"}}>
                                                                T{nb}
                                                            </Typography>
                                                            <Typography variant="subtitle2" sx={{width: "49%"}}>
                                                                {JSON.parse(hoverInfo.properties.nbPieces)[nb]}
                                                            </Typography>
                                                        </Box>)
                                                    })
                                                    }
                                                </Box>
                                            </Box>
                                        </Popup>
                                    )}
                                </Map>
                                <Typography>
                                    La qualité des certaines données issues de la base de données géolocalisées
                                    du
                                    RPLS
                                    peut
                                    être perfectible (certains libellés d’adresses et certaines localisations).
                                </Typography>
                                <Typography>
                                    N’hésitez pas à nous faire part de vos observations pour que nous corrigions
                                    ces
                                    élements.
                                </Typography>
                                <Button
                                    component="a"
                                    variant={"contained"}
                                    sx={{width: 300, backgroundColor: "#f58383"}}
                                    startIcon={<EmailIcon/>}
                                    href={hrefText}
                                >
                                    Demande de correction
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </PDFExport>
        );
    }
}

export default App;
